import { Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const IncomeAndExpenseTopSectionWrapper = styled(Flex)`
  align-items: start;
  gap: 32px;
`
